import PropTypes, { string, bool, number } from 'prop-types';

export const inputsProp = PropTypes.shape({
  type: number,
  buttonTitles: PropTypes.arrayOf(string),
  invalidSelection: PropTypes.string,
  defaultValue: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
  inputs: PropTypes.oneOfType([
    PropTypes.arrayOf(string),
    PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }))
  ]),
  fields: PropTypes.arrayOf(PropTypes.shape({
    placeholder: string,
    required: bool
  }))
});

export const dynamicUpdateProp = PropTypes.shape({
  inputQuestionId: PropTypes.string,
  condition: PropTypes.number,
  expectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  action: PropTypes.number,
  conditionMet: PropTypes.bool
});

const targetProp = PropTypes.shape({
  type: number,
  formType: string,
  formTitle: string,
  nextQuestionId: string
});

const questionProp = PropTypes.shape({
  id: string,
  questionText: string,
  informationBoxReference: string,
  isAnswered: bool,
  hasError: bool,
  errorMessage: string,
  inputs: inputsProp,
  setsPrecondition: PropTypes.number,
  preconditions: PropTypes.arrayOf(PropTypes.number),
  target: PropTypes.shape({
    type: number,
    target: targetProp,
    buttonTargets: PropTypes.arrayOf(targetProp)
  })
});

export default questionProp;
